export const filterOrder: Record<string, number> = {
	in_stock: 0,
	shipped_in_24: 0,
	brand: 1,
	variations: 2,
	main_color_code: 3,
	gender: 4,
	age_group: 5,
	family: 10,
	team: 11,
	motorcycle_brand: 12,
	age_mini: 13,
	drop: 14,
	stability: 15,
	assortment: 17,
	apparel_type: 18,
	shoe_surface: 23,
	sport: 24,
	hardware_connectivity: 26,
	screen_framerate: 27,
	screen_latency: 28,
	screen_resolution: 30,
	screen_size: 31,
	hard_drive_type: 32,
	storage_capacity: 33,
	game_controller_platform: 34,
	hard_drive_external: 35,
	strung: 36,
	head_size: 37,
	string_pattern: 38,
	skill_level: 39,
	racket_weight: 40,
	balance: 41,
	best_price: 99,
};
